import Music from '../components/music';


export default Music;